import B_Real from '../../../../base/dev/child/base/B_Real';
import B_Define from '../../../../base/dev/util/B_Define';
import R_ImageBG from '../image/R_ImageBG';

const init = () => {
    // 배경이 반복하여 나와야하기 때문에 R_Bg 하위에 R_ImageBG 객체 2개가 존재
    return class R_Bg extends B_Real {
        constructor(obj) {
            super(obj);

            this.CODMOS.WORLD.LIST[B_Define.BG_TYPE][this.id] = this;

            const {
                img, full, one = false, speed = 1
            } = obj;

            this.speed = speed;
            this.one = one;

            this._bg1 = new R_ImageBG({
                cm: this.CODMOS,
                id: 'bg1',
                type: B_Define.BG_TYPE,
                res: img,
                full
            });

            this._container.addChild(this._bg1._container);

            // 배경이 한 번 지나가고 사라진다면 R_ImageBG 객체를 하나만 생성
            if (!one) {
                this._bg2 = new R_ImageBG({
                    cm: this.CODMOS,
                    id: 'bg2',
                    type: B_Define.BG_TYPE,
                    res: img,
                    full
                });

                this._bg2._pixelX = this._bg1._w;

                this._container.addChild(this._bg2._container);
            }
        }

        /**
         * [ Function :: _remove ]
         *
         * @DES :: 객체 제거
         * @O.P :: null
         */
        _remove() {
            super._remove();

            delete this.CODMOS.WORLD.LIST[B_Define.BG_TYPE][this.id];
        }

        // 배경의 너비
        get _w() { return this._bg1._w; }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/child/graphic/R_Bg.js